// extracted by mini-css-extract-plugin
export default {"appIllustrationContainer":"ClientApp--appIllustrationContainer--5b869b","appvocacyContainer":"ClientApp--appvocacyContainer--02338e"};